<button
    siriusButton
    iconName="user_circle"
    size="small"
    data-cy="profile-menu-button"
    [attr.aria-label]="'navigation.profile.open' | translate"
    [attr.aria-expanded]="showOverlay$ | async"
    [attr.aria-controls]="overlayId"
    (click)="onClickIcon($event)">
    @if (showOverlay$ | async) {
        <sirius-overlay-menu
            [id]="overlayId"
            [options]="options"
            data-cy="profile-menu-overlay"
            (closeEvent)="onCloseOverlay($event)"
            (clickEvent)="onClickOverlay($event)">
        </sirius-overlay-menu>
    }
</button>
